const copyBtn = () => {

  document.querySelector('.copy-btn')?.addEventListener('click', function () {
    const url = window.location.href as string
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url)
    }
  })
}
export default copyBtn
